import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  timeout: 15000,
});

// İstek interceptor — her isteğe Bearer token ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('cari_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Cevap interceptor — 401'de login sayfasına yönlendir
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('cari_token');
      localStorage.removeItem('cari_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
